<template>
    <div class="order">
        <van-nav-bar title="家长通讯录" left-arrow @click-left="$router.go(-1)" />
        <div style="padding: 10px 20px;">
            <van-button type="primary" block @click="confirmSelection">确定</van-button>
        </div>
        <div v-if="list.length == 0">
            <van-empty description="暂无记录" />
        </div>
        <div v-else>

            <div v-for="item,id in list" :key="item.class_name">
                <h5 style="padding: 10px 20px;"><van-checkbox v-model="checkAllUser[id]" @click="checkAll(id)">全选</van-checkbox>
                </h5>
                <van-checkbox-group v-model="result" ref="checkboxGroup">
                    <van-collapse v-model="activeName" accordion @change="activeChange">
                        <van-collapse-item :title="`${item.class_name}（${item.parent_list.length}人）`"
                            :name="item.class_name">
                            <van-checkbox v-for="(parent, index) in item.parent_list" :key="index" :name="parent">
                                <van-row
                                    style="padding: 10px 10px;margin: 10px 10px;background-color: white;border-radius: 20px;">
                                    <van-col span="6">
                                        <van-image round width="45px" height="45px" src="/img/parents.png" />
                                    </van-col>
                                    <van-col span="18">
                                        <!-- 学生姓名、刷卡时间 -->
                                        <p style="font-size: 16px;color: black;font-weight: bold;">{{ parent.realname }}
                                        </p>
                                        <p style="font-size: 14px;color: grey;">手机号码: {{ parent.phone }}</p>
                                    </van-col>
                                </van-row>
                            </van-checkbox>
                        </van-collapse-item>
                    </van-collapse>
                </van-checkbox-group>
            </div>
        </div>
    </div>
</template>

<script>

import { stuGetParentBook } from '@/api/teacher'
export default {
    name: 'stuGetParentBook',
    components: {

    },
    data() {
        return {
            activeName: '',
            checkAllUser: [],
            currentTeacher: {},
            list: [],
            result: []
        }
    },
    mounted() {
        this.currentTeacher = JSON.parse(localStorage.getItem('userinfo'))
        this.getBook()
    },
    methods: {
        async getBook() {
            const params = {
                tid: this.currentTeacher.userId
            }
            const response = await stuGetParentBook(params)
            console.log('response', response);
            if (response.code == 10000) {
                this.list = response.data
            }
        },
        confirmSelection() {
            console.log('Selected teachers:', this.result)
            if (this.result.length == 0) {
                this.$toast.fail('请至少选择一位家长');
                return
            }
            //处理选中结果，只保留id和realname
            this.result = this.result.map(item => ({
                id: item.id,
                realname: item.realname
            }))
            //将结果存入缓存，返回上一页
            localStorage.setItem('selectedParents', JSON.stringify(this.result));
            this.$router.go(-1);
        },
        checkAll(id) {
            console.log(this.$refs.checkboxGroup);
            this.$refs.checkboxGroup[id].toggleAll();
            this.checkAllUser[id] = !this.checkAllUser[id];
        },
        activeChange(name) {
            console.log('当前展开的面板:', name);
            this.activeName = name
        },
    },
    watch: {
        result(newVal) {
            for (const [id, item] of this.list.entries()) {
                this.checkAllUser[id] = newVal.length === item.parent_list.length;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.order {
    background-color: #fafafa;
}
::v-deep .van-checkbox__label {
   width: 100%;
}
</style>
